export default [
  {
    title: '素材名称和ID',
    key: 'material',
    width: 226,
    type: 'report'
  },

  {
    title: '创意名称/ID',
    key: 'adCreativeName',
    width: 226,
    type: 'report'
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    width: 98,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '实际消耗',
    key: 'amount',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '曝光',
    key: 'pv',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '平均千次曝光费用',
    key: 'avgKPvCost',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '点击',
    key: 'clickNum',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '注册数',
    key: 'newUserNum',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    width: 82,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '新增付费创角数',
    key: 'payRoleUserNum',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '新创角付费次数',
    key: 'newRolePayCnt',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '新创角付费成本',
    key: 'newPayCost',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '每次付费成本',
    key: 'newRolePayCntCost',
    width: 102,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '计划总流水',
    key: 'sumMoney',
    width: 92,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    width: 92,
    type: 'report',
    sortable: 'custom'
  },
  {
    title: '创角次留',
    key: 'createRoleTwoDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角3留',
    key: 'createRoleThreeDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角4留',
    key: 'createRoleFourDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角5留',
    key: 'createRoleFiveDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角6留',
    key: 'createRoleSixDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角7留',
    key: 'createRoleSevenDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角15留',
    key: 'createRoleFifteenDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角30留',
    key: 'createRoleThirtyDayRetainRate',
    width: 72,
    type: 'other'
  },
  {
    title: '创角2日LTV',
    key: 'createRoleTwoDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角3日LTV',
    key: 'createRoleThreeDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角4日LTV',
    key: 'createRoleFourDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角5日LTV',
    key: 'createRoleFiveDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角6日LTV',
    key: 'createRoleSixDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角7日LTV',
    key: 'createRoleSevenDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角15日LTV',
    key: 'createRoleFifteenDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角30日LTV',
    key: 'createRoleThirtyDayLtv',
    width: 92,
    type: 'other'
  }
]
